
import Select from './Select';
import Option from './Option';

Select.Option = Option;

export default Select;


// WEBPACK FOOTER //
// ./components/Select/index.js